module.exports = __webpack_public_path__ + "resources/img/zoom_compat_matrix.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/zoom_compat_matrix.jpg
// module id = 1114
// module chunks = 0